import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

const Posters: React.FC = () => {
  const endpoint = '/posters';
  const title = 'Pôsteres';

  const { projectHash, eventHash } = useParams<IParams>();






  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID' },
    project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto', show: false },
    event_id: { ref: 'event_id', column: 'event_id', label: 'Evento', show: false },
    status: { ref: 'status', column: 'status', label: 'Ativo?' },
    hash: { ref: 'hash', column: 'hash', label: 'Hash', show: false },
    date_text: {
      ref: 'date_text',
      column: 'date_text',
      label: 'Data', show: false,

    },
    category: { ref: 'category', column: 'category', label: 'Categoria' },
    title: { ref: 'title', column: 'title', label: 'Título' },
    email: { ref: 'email', column: 'email', label: 'E-mail', show: false },
    author: { ref: 'author', column: 'author', label: 'Autor' },
    co_authors: { ref: 'co_authors', column: 'co_authors', label: 'Coautores', show: false },
    description: { ref: 'description', column: 'description', label: 'Resumo', show: false },
    image: { ref: 'image', column: 'image', label: 'Imagem', show: false },
    link_url: { ref: 'link_url', column: 'link_url', label: 'Link de Vídeos', show: false },
    video_id: { ref: 'video_id', column: 'video_id', label: 'ID do Vídeo', show: false },
    video_type: { ref: 'video_type', column: 'video_type', label: 'Tipo de Vídeo', show: false },
    have_video: { ref: 'have_video', column: 'have_video', label: 'Têm Vídeo?', show: false },
    eixo: { ref: 'eixo', column: 'eixo', label: 'Eixo', show: false },
    votes: { ref: 'votes', column: 'votes', label: 'Votos' },
    views: { ref: 'views', column: 'views', label: 'Visualizações' },
    institution: { ref: 'institution', column: 'institution', label: 'Instituição' },

    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {

    category: {
      model: 'input',
      type: 'text',
      name: 'category',
      label: 'Categoria',
    },
    eixo: { model: 'input', type: 'text', name: 'eixo', label: 'Eixo' },
    title: { model: 'input', type: 'text', name: 'title', label: 'Título' },
    date_text: { model: 'input', type: 'text', name: 'date_text', label: 'Data em texto' },
    description: {
      model: 'richText',
      type: 'text',
      name: 'description',
      label: 'Descritivo',
    },
    institution: { model: 'input', type: 'text', name: 'institution', label: 'Instituição' },
    email: { model: 'input', type: 'text', name: 'email', label: 'E-mail' },
    author: { model: 'input', type: 'text', name: 'author', label: 'Autor' },
    co_authors: { model: 'input', type: 'text', name: 'co_authors', label: 'Coautores' },

    link_url: { model: 'input', type: 'text', name: 'link_url', label: 'Link' },
    video_id: { model: 'input', type: 'text', name: 'video_id', label: 'ID do Vídeo' },
    video_type: { model: 'input', type: 'text', name: 'video_type', label: 'Tipo de Vídeo' },
    have_video: {
      model: 'selectSimple',
      name: 'have_video',
      label: 'Tem vídeo?',
      defaultValue: 'no',
      options: [
        { label: 'Sim', value: 'yes' },
        { label: 'Não', value: 'no' },
      ],
    },


  };

  const formSchemaUpdate = {
    status: {
      model: 'selectSimple',
      name: 'status',
      label: 'Ativo?',
      defaultValue: 'yes',
      options: [
        { label: 'Sim', value: 'yes' },
        { label: 'Não', value: 'no' },
      ],
    },
    image: { model: "uploadImage", type: "upload", name: "image", label: "Imagem" },
    thumb: { model: "uploadImage", type: "upload", name: "thumb", label: "Thumb" },
    ...formSchema
  };

  const formValidation: Record<string, ValidationSchema> = {

  };


  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default Posters;
